// Yandex.Metrika counter
(function (m, e, t, r, i, k, a) {
  m[i] = m[i] || function () {
    (m[i].a = m[i].a || []).push(arguments)
  }
  m[i].l = 1 * new Date()
  for (var j = 0; j < document.scripts.length; j++) {
    if (document.scripts[j].src === r) return
  }
  k = e.createElement(t)
  a = e.getElementsByTagName(t)[0]
  k.async = 1
  k.src = r
  a.parentNode.insertBefore(k, a)
})(window, document, "script", "https://mc.yandex.ru/metrika/tag.js?id=44147844", "ym")

ym(44147844, "init", {
  ssr: true,
  webvisor: true,
  clickmap: true,
  ecommerce: "dataLayer",
  accurateTrackBounce: true,
  trackLinks: true,
})

document.addEventListener("turbo:load", function() {
  if (typeof ym !== 'undefined') {
    ym(44147844, "hit", window.location.href)
  }
})
// /Yandex.Metrika counter